import React from 'react';

const SpotlerWidget = () => {

  const spotlerSubscriptionUrl = "https://c.spotler.com/ct/m20/k1/qok5K4X5eVyCrqNNGuvyBrRPfVfIVApZwbpfcFs0zhxR5eJyAz2yBev2zyOvNsJxZGhG7embsZhKtuRzpfP9nHZANFtZAX-F2PmfhKtCwII/3crfqS4vMSvsYGh";


  const handleSubscribeClick = () => {
    window.open(spotlerSubscriptionUrl, '_blank');
  };

  return (
    <div className="d-flex w-full justify-content-center">
      <div className="bg-white p-4 w-full max-w-lg fontFamily">
        <h2>Get the latest industry news and updates in your inbox.</h2>
        
        <p className="my-3">
          Subscribe to our newsletter to receive industry insights, job opportunities, 
          and company updates directly to your email.
        </p>
        
        <button
          onClick={handleSubscribeClick}
          className="text-decoration-none primaryBtn m-0 d-inline-block mt-3 px-5 buttonRadius text-center w-25"
          aria-label="Subscribe to newsletter"
        >
          Keep me updated
        </button>
      </div>
    </div>
  );
};

export default SpotlerWidget;